'use strict';

function dateMatcher(d) {
  var ms = d.getTime();
  return function(el) {
    return !!(el && el.getTime) && el.getTime() === ms;
  };
}

module.exports = dateMatcher;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/dateMatcher.js
// module id = 718
// module chunks = 1